import { useEffect } from 'react'
import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Layout from '../Layout'
import FashionLayout from '../../storefronts/indumentaria-femenina/FashionLayout'
import { getSiteSettings } from '../../services/siteSettings.service'
import { useLocation } from 'react-router-dom'

function PublicLayout() {
  const { activeProfile, loading } = useBusinessSettingsContext()
  const location = useLocation()

  useEffect(() => {
    let mounted = true
    const applyTitle = async () => {
      try {
        const sanitizeEnvValue = (value) => typeof value === 'string' ? value.trim().replace(/^['"]|['"]$/g, '').trim() : value
        const settings = await getSiteSettings()
        const envName = sanitizeEnvValue(import.meta.env.VITE_SYSTEM_NAME)
        const title = envName || settings?.hero?.pageTitle
        if (mounted && title) {
          document.title = title
        }
      } catch (error) {
        console.error('Error cargando título del sitio:', error)
      }
    }
    applyTitle()
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash)
      if (el) {
        el.scrollIntoView()
        return
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname, location.search, location.hash])

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionLayout />
  }

  return <Layout />
}

export default PublicLayout
